import React from "react";

const StatusSection = ({ title, statusColor, items, statusKey, remarkKey }) => {
  if (items?.length === 0) return null;

  return (
    <div className="mb-6">
      <h4 className={`text-md  font-semibold text-${statusColor}-600 mb-2`}>
        {title}
      </h4>
      <div className="space-y-4">
        {items?.map((item, index) => (
          <div
            key={index}
            className={`p-5 bg-${statusColor}-50 border-l-4 border-${statusColor}-500 rounded-lg shadow-md`}
          >
            <div className="flex justify-between items-center">
              {/* User Details */}
              <div className="flex items-center gap-3">
                {/* User Avatar (Placeholder) */}
                <div
                  className={`w-10 h-10 flex items-center justify-center bg-${statusColor}-500 text-white font-bold text-sm rounded-full`}
                >
                  {item?.progress?.user?.first_name?.[0] || "U"}
                </div>
                <div>
                  <p className="text-gray-800 font-semibold">
                    {item?.progress?.user?.first_name || "Unknown User"}
                  </p>
                  <span
                    className={`bg-${statusColor}-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-sm`}
                  >
                    {item?.progress?.level || "N/A"}
                  </span>
                </div>
              </div>

              {/* Status Tag */}
              <p
                className={`text-${statusColor}-600 font-semibold text-sm bg-${statusColor}-100 px-3 py-1 rounded-lg`}
              >
                {item?.progress?.status}
              </p>
            </div>

            {/* Remarks (For Rejected Status) */}
            {remarkKey && (
              <p className="mt-2 text-sm text-red-500">
                <span className="font-medium">Remark:</span>{" "}
                {item?.progress?.[remarkKey] || "No remarks provided"}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const ApprovalStatus = ({ matchedData, waitingForApproval }) => {
  const approvedItems = matchedData?.filter(
    (item) => item?.progress?.status === "Approved"
  );
  const rejectedItems = matchedData?.filter(
    (item) => item?.progress?.status === "Rejected"
  );

  console.log("matched data", matchedData);
  return (
    <div className="mt-6">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        Approval Status
      </h3>

      <StatusSection
        title="Approved"
        statusColor="green"
        items={approvedItems}
        statusKey="Approved"
      />
      <StatusSection
        title="Rejected"
        statusColor="red"
        items={rejectedItems}
        statusKey="Rejected"
        remarkKey="remarks"
      />

      {/* Pending Approval Section */}
      {waitingForApproval?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-md font-semibold text-yellow-600 mb-4">
            Pending Approvals
          </h3>
          <div className="space-y-4">
            {waitingForApproval.map((item, index) => (
              <div
                key={index}
                className="p-4 bg-yellow-50 border-l-4 border-yellow-500 rounded-lg shadow-md"
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-10 h-10 flex items-center justify-center bg-yellow-500 text-white font-bold text-sm rounded-full`}
                    >
                      {item?.user?.[0] || "U"}
                    </div>
                    <div>
                      <p className="text-gray-800 font-semibold">
                        {item?.user || "Unknown User"}
                      </p>
                      <span className="bg-yellow-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
                        {item?.level || "N/A"}
                      </span>
                    </div>
                  </div>
                  <p className="text-yellow-600 font-semibold text-sm bg-yellow-100 px-3 py-1 rounded-lg">
                    ⏳ Waiting for Approval
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ApprovalStatus;
